import { useT } from '@/lib/useLang';

/**
 * NeverZero face aux trois autres réponses au « post à zéro » : un pod, des
 * likes achetés, ne rien faire. Pour le visiteur qui connaît déjà ces options
 * et se demande pourquoi payer celle-ci. Les cellules des concurrents restent
 * au conditionnel (« souvent ») : on ne décrit pas un produit précis.
 */
export function Comparison() {
  const t = useT();

  return (
    <section className="nz-section">
      <div className="nz-compare__head">
        <div className="nz-eyebrow">{t.compareEyebrow}</div>
        <h2 className="nz-h2">{t.compareH2}</h2>
      </div>

      <div className="nz-compare__scroll">
        <table className="nz-compare__table">
          <thead>
            <tr>
              <td />
              {t.compareCols.map((col, i) => (
                <th key={col} scope="col" className={i === 0 ? 'nz-compare__us' : undefined}>
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {t.compareRows.map((row) => (
              <tr key={row.label}>
                <th scope="row">{row.label}</th>
                {row.cells.map((cell, i) => (
                  <td key={t.compareCols[i]} className={i === 0 ? 'nz-compare__us' : undefined}>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
